import { useEffect, useRef, useState } from "react";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

const DeleteModal = (props) => {

    const { modalOpen, onClose, todoTitle, onDelete, children} = props;
    const ref = useRef();
    const [hasChildren, setHasChildren] = useState(null);
    const isMobile = useIsMobile();

    const getChildren = (children) => {
        if (children) {
            return " and all its tasks.";
        } else {
            return "?";
        }
    };

    const handleClose = () => {
        onClose();
        ref.current?.close();
    };

    const handleDeleteTask = () => {

        onDelete();
        ref.current?.close();
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (modalOpen) {
            setHasChildren(getChildren(children));
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

    }, [modalOpen]);



    return (
        <dialog className="gt-modal" aria-labelledby="deleteTodo" ref={ref}>
            <div className="gt-modal-content">
                <div className="gt-modal-content__heading">
                    <h2 id="smartAssistant">Delete Task</h2>
                    <button className="gw-icon-button gw-icon-button--icon" aria-label="close delete modal"
                        onClick={() => { handleClose() }}
                    >
                        <i className="gw-icon-button__icon gw-button__icon--close"></i>
                    </button>
                </div>
                <div className="gt-modal-content__body" style={{fontSize: '24'} }>
                    <p>Are you sure you want to delete <strong>{todoTitle}</strong>{hasChildren}</p>
                </div>
                <div style={{ display: "flex", justifyContent: "right", padding: '1.5em' }}>
                    
                    <button className="gw-button gw-button--secondary"
                        onClick={() => { handleClose() }}
                        style={{ marginRight: '0.5em' }}
                    >Cancel</button>
                   
                    <button className="gw-button gt-button-field--secondary" style={{ backgroundColor: '#D4262A', color: '#fff'}}
                        onClick={() => { handleDeleteTask() }} 
                    >Delete</button>
                </div>
            </div>
        </dialog>
    );
}

export default DeleteModal;